import { Button } from 'components/Button/Button'
import React, { useState } from 'react'
import { MyTextField } from './MyTextField'
import { IconEyeHide } from 'components/Icon/IconEyeHide'
import { IconEyeShow } from 'components/Icon/IconEyeShow'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'

/**
 * Defines the props for the MyTextField component
 */
type MyTextFieldPasswordProps = {
  name: string
  ariaLabel?: string
  label?: React.ReactNode
  hint?: React.ReactNode
  type?: string
  inputMode?:
    | 'text'
    | 'numeric'
    | 'none'
    | 'tel'
    | 'url'
    | 'email'
    | 'decimal'
    | 'search'
  multiline?: boolean
  className?: string
  fieldClassName?: string
  labelClassName?: string
  errorMessageClassName?: string
  autoComplete?: string
  placeholder?: string
  isCurrentlyValid?: boolean
  maxLength?: number
  addErrorPrefix?: boolean
  onBlur?: () => void
  /**
   * Defines a pattern to replace when input is given to the textfield.
   * This is usually similar, but different than pattern validation
   * rules. For instance, this regex might be /^a/g meaning to replace
   * all characters that are not 'a', while the matching validation
   * rule would be /^[a]+$/, meaning that it must start and only
   * contain a's
   */
  pattern?: RegExp | string
  'aria-required'?: boolean
} & Omit<Parameters<typeof Controller>[0], 'render' | 'control'>

export const MyTextFieldPassword: React.FC<MyTextFieldPasswordProps> = ({
  ...props
}) => {
  const { t } = useTranslation('common')
  const [isPasswordHidden, setIsPasswordHidden] = useState<boolean>(true)
  return (
    <div className="masked-wrapper">
      <MyTextField
        fieldClassName="password-padding"
        type={isPasswordHidden ? 'password' : 'text'}
        {...props}
      />
      <Button
        className="my-u-p--2 masked-eye ds-c-button ds-c-button--ghost ds-u-text-decoration--none"
        onClick={() => setIsPasswordHidden(!isPasswordHidden)}
      >
        <div className="ds-u-display--flex ds-u-align-items--center">
          <div className="my-u-mr--1">
            {isPasswordHidden ? <IconEyeShow /> : <IconEyeHide />}
          </div>
          <div className="my-u-pt--1 ">
            {isPasswordHidden ? t('show') : t('hide')}
          </div>
        </div>
      </Button>
    </div>
  )
}
